import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { v4 } from 'uuid';
import set from 'lodash-es/set';
import { convertRowIndexPathToNumberArray, getByRowIndexPath, getParentRowIndexPath } from '../util/rowIndexPath.js';
import unset from 'lodash-es/unset';
import get from 'lodash-es/get';
import compact from 'lodash-es/compact';
import pullAt from 'lodash-es/pullAt';

var insertChildTableRow = function insertChildTableRow(data, rowIndexPath, values) {
  if (rowIndexPath === void 0) {
    rowIndexPath = undefined;
  }

  if (values === void 0) {
    values = {};
  }

  var nexTRow = JSON.parse(JSON.stringify(data));
  var childRowIndexPath;

  if (rowIndexPath) {
    var _currentRow$subRows;

    var rowIndexes = convertRowIndexPathToNumberArray(rowIndexPath);
    var currentRow = getByRowIndexPath(nexTRow, rowIndexes.join('.'));
    var nextSubRows = (_currentRow$subRows = currentRow === null || currentRow === void 0 ? void 0 : currentRow.subRows) !== null && _currentRow$subRows !== void 0 ? _currentRow$subRows : [];
    var path = rowIndexes.map(function (i) {
      return "[" + i + "]";
    }).join('.subRows') + '.subRows';
    nextSubRows.unshift(values);
    set(nexTRow, path, nextSubRows); // rebuild the new id

    rowIndexes.push(0);
    childRowIndexPath = rowIndexes.join('.');
  } else {
    nexTRow.unshift(values);
    childRowIndexPath = '0';
  }

  return [nexTRow, childRowIndexPath];
};
var removeChildTableRow = function removeChildTableRow(data, rowIndexPath) {
  var nexTRow = JSON.parse(JSON.stringify(data));
  var rowIndexes = convertRowIndexPathToNumberArray(rowIndexPath);
  var rootIndex = Number(rowIndexes.shift());

  if (rowIndexes.length) {
    // unset
    var unsetPath = rowIndexes.map(function (index) {
      return "subRows[" + index + "]";
    }).join('.');
    unset(nexTRow[rootIndex], unsetPath); // remove empty value from subRows

    rowIndexes.pop();
    var setPath = rowIndexes.length ? rowIndexes.map(function (index) {
      return "subRows[" + index + "]";
    }).join('.') + '.subRows' : 'subRows';
    set(nexTRow[rootIndex], setPath, compact(get(nexTRow[rootIndex], setPath)));
  } else {
    pullAt(nexTRow, rootIndex);
  }

  return nexTRow;
};
var useTableRowCreation = function useTableRowCreation(data, tableRef) {
  var _React$useState = React__default.useState(JSON.parse(JSON.stringify(data))),
      internalData = _React$useState[0],
      setInternalData = _React$useState[1];

  var _React$useState2 = React__default.useState(undefined),
      activeRowIndexPath = _React$useState2[0],
      setActiveRowIndexPath = _React$useState2[1];

  React__default.useEffect(function () {
    if (activeRowIndexPath !== undefined) {
      // keep the same edit key, so that we don't remount the row/form
      var currentRow = getByRowIndexPath(internalData, activeRowIndexPath); // get the active creation rows parent

      var parentId = getParentRowIndexPath(activeRowIndexPath); // insert a new empty row in the external data (with the same key)

      var _insertChildTableRow = insertChildTableRow(JSON.parse(JSON.stringify(data)), parentId, currentRow),
          nexTRow = _insertChildTableRow[0],
          newRowIndexPath = _insertChildTableRow[1]; // update and set that row as active, we basically just changed it's position in our internal data


      setActiveRowIndexPath(newRowIndexPath);
      setInternalData(nexTRow);

      if (tableRef !== null && tableRef !== void 0 && tableRef.current) {
        tableRef.current.instance.toggleRowEditing(currentRow === null || currentRow === void 0 ? void 0 : currentRow._createKey);
      }
    } else {
      setInternalData(data);
    }
  }, [JSON.stringify(data)]);

  var create = function create(rowIndexPath, values) {
    if (rowIndexPath === void 0) {
      rowIndexPath = undefined;
    }

    if (values === void 0) {
      values = {};
    }

    var _createKey = v4();

    var _insertChildTableRow2 = insertChildTableRow(internalData, rowIndexPath, _extends({}, values, {
      _createKey: _createKey
    })),
        nexTRow = _insertChildTableRow2[0],
        newRowIndexPath = _insertChildTableRow2[1];

    setActiveRowIndexPath(newRowIndexPath);
    setInternalData(nexTRow);

    if (tableRef !== null && tableRef !== void 0 && tableRef.current) {
      tableRef.current.instance.toggleRowEditing(_createKey);
    }

    return newRowIndexPath;
  };

  var remove = function remove(rowIndexPath) {
    var nexTRow = removeChildTableRow(internalData, rowIndexPath);
    setInternalData(nexTRow);
    setActiveRowIndexPath(undefined);
  };

  return {
    data: internalData,
    create: create,
    remove: remove,
    isCreating: activeRowIndexPath !== undefined
  };
};

export { insertChildTableRow, removeChildTableRow, useTableRowCreation };
//# sourceMappingURL=useRowCreation.js.map
